import { Banner } from '@flipster/apis/v1/banner/types';
import { BaseFaqItemFragment } from '@flipster/features/src/contentful/faq/query.generated';
import { css } from '@flipster/styled-system/css';

import { AppDownloadSection } from '../_app-download/section';
import Announcement from './sections/Announcement';
import CurrentActivities from './sections/CurrentActivities';
import BaseHero from './sections/Hero/BaseHero';
import LiveThisWeek from './sections/LiveThisWeek';
import Partners from './sections/Partners';
import Products from './sections/Products';
import Promotions from './sections/Promotions';
import UniqueSettlingPoint from './sections/UniqueSettlingPoint';
import { Faq } from './sections/faq';

interface Props {
  heroCarousel?: Banner[];
  promotions?: Banner[];
  faqs?: BaseFaqItemFragment[];
}

const BaseMain = ({ heroCarousel, promotions, faqs }: Props) => {
  return (
    <main className={css({ pos: 'relative', overflowX: 'hidden' })}>
      <BaseHero heroCarousel={heroCarousel} />
      <LiveThisWeek />
      <Announcement css={{ mt: 48 }} />
      <Promotions promotions={promotions} />
      {/* [rwa-task]: Products section rearrange for 2 weeks*/}
      <Products />
      <UniqueSettlingPoint />
      <CurrentActivities />
      <Partners />
      <Faq faqs={faqs} css={{ mt: 0, pb: { base: 48, tablet: 96 } }} />
      <AppDownloadSection />
    </main>
  );
};

export default BaseMain;
